export const userActionTypes = {
  LOGIN_USER: '@user/LOGIN_USER',
  LOGIN_USER_START: '@user/LOGIN_USER_START',
  LOGIN_USER_ERROR: '@user/LOGIN_USER_ERROR',

  SIGN_UP_USER: '@user/SIGN_UP_USER',
  SIGN_UP_USER_START: '@user/SIGN_UP_USER_START',
  SIGN_UP_USER_ERROR: '@user/SIGN_UP_USER_ERROR',

  LOGOUT_USER: '@user/LOGOUT_USER',

  SET_IS_LOGGED_IN: '@user/SET_IS_LOGGED_IN',

  GET_CURRENT_USER: '@user/GET_CURRENT_USER',
  GET_CURRENT_USER_START: '@user/GET_CURRENT_USER_START',
  GET_CURRENT_USER_ERROR: '@user/GET_CURRENT_USER_ERROR',

  VERIFY_USER: '@user/VERIFY_USER',
  VERIFY_USER_START: '@user/VERIFY_USER_START',
  VERIFY_USER_ERROR: '@user/VERIFY_USER_ERROR',

  GET_ALL_EMPLOYEES: '@user/GET_ALL_EMPLOYEES',
  GET_ALL_EMPLOYEES_START: '@user/GET_ALL_EMPLOYEES_START',
  GET_ALL_EMPLOYEES_ERROR: '@user/GET_ALL_EMPLOYEES_ERROR',

  GET_ALL_CLIENTS: '@user/GET_ALL_CLIENTS',
  GET_ALL_CLIENTS_START: '@user/GET_ALL_CLIENTS_START',
  GET_ALL_CLIENTS_ERROR: '@user/GET_ALL_CLIENTS_ERROR',

  UPDATE_CLIENT: '@user/UPDATE_CLIENT',
  UPDATE_CLIENT_START: '@user/UPDATE_CLIENT_START',
  UPDATE_CLIENT_ERROR: '@user/UPDATE_CLIENT_ERROR',
};
